module.exports = __webpack_public_path__ + "static/media/JungleBell.46ffe4ef.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/constants/JungleBell.mp3
// module id = 96
// module chunks = 0